import { Reducer } from 'redux';
import { Actions, DeviceRegistration } from 'constants/alexaIntegrationConstants';
import AlexaIntegrationState, { initialProfileState } from 'state/AlexaIntegrationState';

const alexaIntegrationReducer: Reducer<AlexaIntegrationState> =
  (state: AlexaIntegrationState = new AlexaIntegrationState(), action) => {
    switch (action.type) {
      case Actions.ALEXA_CREDENTIAL_SUCCESS:
        return state
          .set('roleArn', action.payload.roleArn)
          .set('externalId', action.payload.externalId)
          .set('authenticated', !!(action.payload.roleArn && action.payload.externalId))
          .set('integrationStatus', null);
      case Actions.ALEXA_DISCONNECT_SUCCESS:
        return new AlexaIntegrationState();
      case Actions.ALEXA_AUTH_SUCCESS:
        return state
          .set('roleArn', action.payload.roleArn)
          .set('externalId', action.payload.externalId)
          .set('integrationStatus', action.type)
          .set('authenticated', true);
      case Actions.ALEXA_AUTH_ERROR:
        return state
          .set('authenticated', false)
          .set('integrationStatus', action.type);
      case Actions.ALEXA_DEVICE_STATE_SUCCESS:
        return state
          .set('devices', {...state.get('devices'), ...action.payload});
      case Actions.ALEXA_DEVICE_STATE_FAILURE:
        const failedDevice = state.get('devices')[action.payload];
        if (!failedDevice) {
          return state;
        }
        failedDevice.state = DeviceRegistration.FAILED;
        return state
          .set('devices', {...state.get('devices'), ...{[action.payload]: failedDevice }});
      case Actions.ALEXA_DEVICE_REMOVAL_SUCCESS:
        const devices = state.get('devices');
        delete devices[action.payload];
        return state
          .set('devices', devices);
      case Actions.ALEXA_GET_PROFILE_SUCCESS:
        return state
          .set('profileData', action.payload)
          .set('profileError', null);
      case Actions.ALEXA_GET_PROFILE_FAILURE:
        return state
          .set('profileData', initialProfileState)
          .set('profileError', action.payload);
      case Actions.SELECT_ALEXA_DEVICE:
        return state
          .set('selectedDevice', action.payload);
      case Actions.ALEXA_CREDENTIAL_FAILURE:
      case Actions.ALEXA_DISCONNECT_FAILURE:
      default:
        return state;
    }
  };

export default alexaIntegrationReducer;
